import { CustomDataComponent } from "../../core/models/common/custom-data-component.model";

// Borders-----
// Boton rectangular con borde rojo sin fondo y con texto
export function OutlinedButton(labelKey: string, icon: string, action: string): CustomDataComponent {
  return {
    labelKey,
    icon,
    action,
    styleClass: 'p-button-danger p-button-outlined'
  };
}

// Boton rectangular con borde secundario (gris) sin fondo y con texto
export function OutlinedSecondaryButton(labelKey: string, icon: string, action: string): CustomDataComponent {
  return {
    labelKey,
    icon,
    action,
    styleClass: 'p-button-secondary p-button-outlined'
  };
}

// Boton rectangular con borde blanco sin fondo y con texto
export function OutlinedButtonWhite(labelKey: string, icon: string, action: string): CustomDataComponent {
  return {
    labelKey,
    icon,
    action,
    styleClass: 'btn-button-white p-button-outlined'
  };
}
// -------

// Sin Bordes-----
// Boton rectangular sin borde sin fondo y con texto
export function NormalButton(labelKey: string, icon: string, action: string): CustomDataComponent {
  return {
    labelKey,
    icon,
    action,
    styleClass: 'p-button-secondary'
  };
}
// -------

// Circulares-----
// Boton circular con borde normal (azul) sin fondo y sin texto
export function OutlinedNormalCircleButton(icon: string, action: string): CustomDataComponent {
  return {
    icon,
    action,
    styleClass: 'edit-btn-circle'
  };
}

// Boton circular con borde rojo sin fondo y sin texto
export function OutlinedCircleButton(icon: string, action: string): CustomDataComponent {
  return {
    icon,
    action,
    styleClass: 'delete-btn-circle'
  };
}
// -------

export const EDIT_ACTION_CIRCLE: CustomDataComponent = OutlinedNormalCircleButton(
  'pi pi-pencil',
  'edit'
);

export const VIEW_ACTION_CIRCLE: CustomDataComponent = OutlinedNormalCircleButton(
  'pi pi-eye',
  'view'
);

export const CHECK_ACTION: CustomDataComponent = OutlinedNormalCircleButton(
  'pi pi-check',
  'check'
);

export const REJECT_ACTION: CustomDataComponent = OutlinedCircleButton(
  'pi pi-thumbs-down',
  'reject'
);

export const DELETE_ACTION_CIRCLE: CustomDataComponent = OutlinedCircleButton(
  'pi pi-trash',
  'delete'
);

export const POWER_ACTION_CIRCLE: CustomDataComponent = OutlinedCircleButton(
  'pi pi-power-off',
  'power'
);


export const CANCEL_ACTION: CustomDataComponent = OutlinedCircleButton(
  'pi pi-times',
  'cancel'
);

export const REMOVE_ACTION: CustomDataComponent = {
  icon: 'pi pi-times',
  labelKey: 'common.delete',
  action: 'remove',
  styleClass: 'delete-btn-circle'
};

export const EXPORT_BUTTON: CustomDataComponent = NormalButton(
  'common.export',
  'pi pi-upload',
  'export'
);

export const EXPORT_EXCEL_BUTTON: CustomDataComponent = NormalButton(
  'common.exportExcel',
  'pi pi-upload',
  'export-excel'
);

export const EXPORT_PDF_BUTTON: CustomDataComponent = NormalButton(
  'common.exportPdf',
  'pi pi-upload',
  'export-pdf'
);

export const IMPORT_BUTTON: CustomDataComponent = {
  labelKey: 'common.import',
  icon: 'pi pi-file-import',
  action: 'import',
  styleClass: 'p-button-secondary'
};

export const ADD_NEW_BUTTON: CustomDataComponent = OutlinedButton(
  'common.addNew',
  'pi pi-user-plus',
  'add'
);

export const CREATE_VEHICLE_BUTTON: CustomDataComponent = OutlinedButton(
  'common.createVehicle',
  'pi pi-car',
  'add-vehicle'
);

export const CREATE_ADVICE_BUTTON: CustomDataComponent = OutlinedButton(
  'common.requestAdvice',
  'pi pi-comments',
  'add-advice'
);

export const ADD_METHOD_PAYMENT_BUTTON: CustomDataComponent = OutlinedButton(
  'common.addPaymentMethod',
  'pi pi-plus',
  'add-payment-method'
);

export const UPDATE_INFO_BUTTON: CustomDataComponent = OutlinedButton(
  'common.updateInfo',
  'pi pi-user-edit',
  'update-info'
);

export const SHOW_MORE_BUTTON: CustomDataComponent = OutlinedButton(
  'common.showMore',
  'pi pi-angle-down',
  'show-more'
);

export const SCHEDULE_SERVICE_BUTTON: CustomDataComponent = OutlinedButton(
  'common.scheduleService',
  'pi pi-calendar',
  'schedule-service'
);

export const SCHEDULE_WASH_BUTTON: CustomDataComponent = OutlinedButtonWhite(
  'common.scheduleWash',
  'pi pi-calendar',
  'schedule-wash'
);

export const SCHEDULE_OFF_BUTTON: CustomDataComponent = OutlinedButtonWhite(
  'common.scheduleDiscount',
  'pi pi-calendar',
  'schedule-off'
);

export const WATCH_ALL_ACTION: CustomDataComponent = OutlinedButton(
  'common.viewAll',
  '',
  'watch'
);

export const CHANGE_PHOTO_BUTTON: CustomDataComponent = OutlinedButton(
  'common.changePhoto',
  'pi pi-camera',
  'change-photo'
);

export const CHOOSE_FILE_BUTTON: CustomDataComponent = {
  labelKey: 'common.chooseFile',
  icon: 'pi pi-plus',
  action: 'choose-file',
  styleClass: 'btn-general'
};
export const UPLOAD_FILE_BUTTON: CustomDataComponent = {
  labelKey: 'common.upload',
  icon: 'pi pi-upload',
  action: 'upload-file',
  styleClass: 'p-button-secondary'
};
export const DOWNLOAD_FILE_BUTTON: CustomDataComponent = {
  labelKey: 'common.downloadTemplate',
  icon: 'pi pi-download',
  action: 'download-file',
  styleClass: 'p-button-secondary'
};
export const CANCEL_BUTTON: CustomDataComponent = {
  labelKey: 'common.cancel',
  icon: 'pi pi-times',
  action: 'cancel',
  styleClass: 'p-button-secondary'
};


export const DOWNLOAD_BILLING_BUTTON: CustomDataComponent = OutlinedSecondaryButton(
  "common.downloadBilling",
  "pi pi-download",
  "download-billing"
);
